var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('span',{staticClass:"pdf-viewer-close-button",on:{"click":function($event){return _vm.$emit('closePdf')}}},[_vm._v("×")]),_c('ejs-pdfviewer',{style:({'height': _vm.documentHeight + 'px'}),attrs:{"id":"pdfViewer","resourceUrl":_vm.resourceUrl,"printMode":_vm.printMode,"documentPath":_vm.documentPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }